import { isEmpty } from 'lodash';
import * as Yup from 'yup';

export const deptValidationSchema = (
  t,
  deptLabel,
  specificGoalSelected,
  isEdit = false
) => {
  let validations = {
    name: Yup.string().required(
      `${deptLabel} ${t('formulary.validation.name_required')}`
    ),
    description: Yup.string().required(
      t('formulary.validation.description_required')
    ),
    goals: specificGoalSelected
      ? Yup.array().required(t('formulary.validation.goal_required'))
      : Yup.array().optional(),
  };

  /******
  if (!isDepartment && isEdit) {
    validations = {
      ...validations,
      departmentId: Yup.string().required('Department is required!'),
    };
  }
  *********/

  return Yup.object().shape(validations);
};

export const deptInitialValues = (dept = null) => {
  return {
    name: dept?.name || '',
    description: dept?.description || '',
    parentDepartmentId: dept?.parentDepartmentId || null,
    goalTitle: [110],
    goals: !isEmpty(dept?.departmentGoals)
      ? dept.departmentGoals.map((goal) => goal.id)
      : [],
  };
};
